import { Chip, ChipProps } from '@mui/material';
import Decimal from 'decimal.js';
import { useMemo } from 'react';

export type PercentChipProps = Omit<ChipProps<'div', { value: Decimal.Value }>, 'label'>;

export function PercentChip({ value, ...props }: PercentChipProps) {
  const text = useMemo(() => new Decimal(value).mul(100).toFixed(2) + '%', [value]);
  return <Chip color="primary" size="small" label={text} {...props} />;
}
